import { BarChart as type } from "d3plus-plot";
import Shell from "./Viz";
/**
    @class BarChart
    @extends Viz
*/

var BarChart = function (Shell) {
  function BarChart() {
    Shell.apply(this, arguments);
  }

  if (Shell) BarChart.__proto__ = Shell;
  BarChart.prototype = Object.create(Shell && Shell.prototype);
  BarChart.prototype.constructor = BarChart;
  return BarChart;
}(Shell);

BarChart.defaultProps = Object.assign({}, Shell.defaultProps, {
  type: type
});
export default BarChart;